import React from "react";
import AzkarListHeader from "../../AzkarList/AzkarListHeader";
import { Container } from "../../Container/Container";
import Navbar from "../../Navbar/Navbar";
import azkarSafarData from "./AzkarSafarData";

function AzkarSafar() {
  return (
    <>
      <Navbar brand={azkarSafarData.brand} />
      <Container>
        <AzkarListHeader List={azkarSafarData.list} />
      </Container>
    </>
  );
}

export default AzkarSafar;
